import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ErrorLoggerService {

  constructor() { }

  async logMessage(message: any, title: string)
  {
    const timestamp = new Date();
    //console.error(`Error:- ${timestamp}`, error.error);

    console.groupCollapsed(
      `%c${title}-%c: ${await this.formatTimestamp(timestamp)}`, 
      "color: blue; font-size: 14px; font-weight: bold;", 
      "color: orange;");

    console.log(`%c${JSON.stringify(message)}`, "color: blue; font-size: 13px; font-weight: bold;");
    console.groupEnd();
  } 

  async logErrorNew(title: string, ...error: any)
  {
    const timestamp = new Date();
    //console.error(`Error:- ${timestamp}`, error.error);

    console.groupCollapsed(
      `%cERROR%c: ${await this.formatTimestamp(timestamp)}-%c${title}`, 
      "color: red; font-size: 14px; font-weight: bold;", 
      "color: blue;",
      "color: red;");

    console.log(`%c${JSON.stringify(error)}`, "color: red; font-size: 13px; font-weight: bold;");
    console.groupEnd();
  } 

  async logError(error: any, title: string)
  {
    const timestamp = new Date();
    //console.error(`Error:- ${timestamp}`, error.error);

    console.groupCollapsed(
      `%cERROR%c: ${await this.formatTimestamp(timestamp)}-%c${title}`, 
      "color: red; font-size: 14px; font-weight: bold;", 
      "color: blue;",
      "color: red;");

    console.log(`%c${JSON.stringify(error.error)}`, "color: red; font-size: 13px; font-weight: bold;");
    console.groupEnd();
  } 

  async formatTimestamp(date: Date): Promise<string> {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  
    const dayOfWeek = daysOfWeek[date.getDay()];
    const day = date.getDate().toString().padStart(2, '0'); // Ensure 2 digits
    const month = monthsOfYear[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0'); // Ensure 2 digits
    const minutes = date.getMinutes().toString().padStart(2, '0'); // Ensure 2 digits
    const seconds = date.getSeconds().toString().padStart(2, '0'); // Ensure 2 digits
  
    return `${dayOfWeek} ${day}-${month}-${year}: ${hours}:${minutes}:${seconds}`;
  }
  
}
